import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'clampNumber' })
export class ClampNumberPipe implements PipeTransform {
    transform(number: number, min = 0, max = 100): number {
        return Math.min(max, Math.max(min, number));
    }
}
